import type { Schema } from '@cli-types/core-engine/schema.js'
import { collectSchemaSlotLayoutErrors } from './collect-schema-slot-layout-errors.js'
import { normalizeSchemaSlotLayout } from './normalize-schema-slot-layout.js'

export function normalizeLoadedSchema(parsed: unknown): Schema {
  const schema = parsed as Schema
  const slotLayoutErrors: string[] = []
  collectSchemaSlotLayoutErrors(schema, slotLayoutErrors)

  if (slotLayoutErrors.length > 0) {
    throw new Error(slotLayoutErrors.join('; '))
  }

  return normalizeSchemaSlotLayout(schema)
}
